import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import CourseApproval from 'components/Auth/CourseApproval';
import AuthModule from 'containers/AuthModule';
import CourseDashboard from 'containers/CourseDashboard';
import Logout from 'containers/Logout';
import MessagePage from 'containers/MessagePage';
import ProtectedRoute from 'ProtectedRoute';
import { RootState } from 'redux/reducers';
import { ROUTES } from 'routes';

import css from './App.module.scss';
import Header from './components/Header';
import AdminDashboard from './containers/AdminDashboard';
import Course from './containers/Course';
import Main from './containers/Main';

interface AppProps {
  isAppLoading: boolean;
  getAccess: SessionData | null;
}

const App: FC<AppProps> = (props) => {
  return (
    <div className='app'>
      <Header title={<HeaderTitle getAccess={props.getAccess} />} />
      <div className='app__content'>
        <Switch>
          <Route path={[ROUTES.LTI_LAUNCH_REDIR, ROUTES.AUTH_REDIRECT]} component={Main} />
          <Route path={ROUTES.AUTH} component={AuthModule} />
          <Route path={ROUTES.LOG_OUT} component={Logout} />
          <Route path={ROUTES.COURSE_APPROVAL} component={CourseApproval} />
          <ProtectedRoute forContext='course' path={ROUTES.COURSES} component={CourseDashboard} />
          <ProtectedRoute forContext='course' path={ROUTES.COURSES_CREATE} exact component={Course} />
          <ProtectedRoute forContext='organization' path={ROUTES.ADMIN} component={AdminDashboard} />
          <Route path={ROUTES.MESSAGE_PAGE} component={MessagePage} />
          <Redirect
            to={{ pathname: ROUTES.MESSAGE_PAGE, state: { code: '404', message: 'Page not found' } }}
          />
        </Switch>
      </div>
    </div>
  );
};

interface HeaderTitleProps {
  getAccess: SessionData | null;
}

export const HeaderTitle: FC<HeaderTitleProps> = ({ getAccess }) => {
  if (!getAccess) return null;
  return (
    <div>
      {getAccess.context === 'course' ? (
        <div>
          <div className={css['course-code']}>{getAccess.courseDetails.code}</div>
          <div className={css['course-title']}>{getAccess.courseDetails.title}</div>
        </div>
      ) : (
        <div>{getAccess.organizationDetails.name}</div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    isAppLoading: state.isAppLoading,
    getAccess: state.getAccess,
  };
};

export default connect(mapStateToProps)(App);
